/** Caixa de texto livre sobre o desenho do plano de corte (posição em % da área da chapa). */
export interface CaixaTextoPlano {
  id: string;
  texto: string;
  /** 0–100, relativo à largura da chapa no desenho */
  xPct: number;
  /** 0–100, relativo à altura da chapa no desenho */
  yPct: number;
  wPct: number;
  hPct: number;
  /** Tamanho da fonte em pontos (impressão e tela) */
  fontSizePt: number;
}

export function criarCaixaTextoPlano(parcial?: Partial<CaixaTextoPlano>): CaixaTextoPlano {
  return {
    id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `cx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    texto: '',
    xPct: 8,
    yPct: 8,
    wPct: 28,
    hPct: 14,
    fontSizePt: 10,
    ...parcial,
  };
}
